import { render, staticRenderFns } from "./AddToImageGroupModal.vue?vue&type=template&id=279b2ad6&scoped=true"
import script from "./AddToImageGroupModal.vue?vue&type=script&lang=js"
export * from "./AddToImageGroupModal.vue?vue&type=script&lang=js"
import style0 from "./AddToImageGroupModal.vue?vue&type=style&index=0&id=279b2ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279b2ad6",
  null
  
)

export default component.exports